import { useEffect, useMemo, useState } from 'react';
import api from '@/api';
import { API_COMPANY_CAR, PATH_COMPANY_CAR_WRITE } from '@/constants/constant';
import { pcompany } from '@/proto/proto';
import { Button, Select, Typography } from 'antd';
import { Link } from 'react-router-dom';

type CompanyCarSelectorProps = {
  onChange?: (car: string) => void;
};

const CompanyCarSelector = ({ onChange }: CompanyCarSelectorProps) => {
  const [cars, setCars] = useState<pcompany.PbCompanyCar[]>([]);

  useEffect(() => {
    api.get(API_COMPANY_CAR, { params: { companyId: 1, size: 100, status: 1 } }).then(({ data }) => {
      setCars(data.car);
    });
  }, []);

  return (
    <Select
      style={{ width: '100%' }}
      notFoundContent={
        <>
          <Typography>등록된 차량 정보가 없습니다.</Typography>
          <Button>
            <Link to={PATH_COMPANY_CAR_WRITE}>차량 등록</Link>
          </Button>
        </>
      }
      onSelect={(value) => {
        if (onChange) {
          onChange(`${value}`);
        }
      }}
      options={cars?.map((car: pcompany.IPbCompanyCar) => ({
        label: car.plateNo,
        value: `${car.base?.id}`,
      }))}
    />
  );
};

CompanyCarSelector.defaultProps = {
  onChange: undefined,
};

export default CompanyCarSelector;
